var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screenfull"
  }, [_c('div', {
    staticClass: "full-screen-btn-con",
    on: {
      "click": _vm.click
    }
  }, [_c('Icon', {
    attrs: {
      "type": _vm.isFullscreen ? 'arrow-shrink' : 'arrow-expand',
      "size": 23
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71e5b860","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Screenfull.vue
// module id = SQSv
// module chunks = 166